function isObject(thing: unknown): thing is Record<string, unknown> {
  return thing != null;
}

export function assertStringKey<K extends string>(
  thing: unknown,
  key: K,
  {
    errorMessage,
  }: {
    errorMessage?: (key: K) => string;
  } = {},
): asserts thing is Record<K, string> {
  if (process.env.NODE_ENV !== 'production') {
    if (!isObject(thing) || typeof thing[key] !== 'string') {
      throw new Error(
        errorMessage?.(key) ?? `Object must have property: ${key}`,
      );
    }
  }
}

export function assertOneOfKeys<K extends string>(
  thing: unknown,
  keys: K[],
  {
    errorMessage,
  }: {
    errorMessage?: (keys: K[]) => string;
  } = {},
): asserts thing is Record<K, string> {
  if (process.env.NODE_ENV !== 'production') {
    if (
      !isObject(thing) ||
      !keys.some((key) => typeof thing[key] === 'string')
    ) {
      throw new Error(
        errorMessage?.(keys) ??
          `Object must have one of properties: ${keys.join(', ')}`,
      );
    }
  }
}

export function assertKey<K extends string>(
  thing: unknown,
  key: K,
  {
    errorMessage,
  }: {
    errorMessage?: (key: K) => string;
  } = {},
): asserts thing is Record<K, undefined> {
  if (process.env.NODE_ENV !== 'production') {
    if (!isObject(thing) || !(key in thing)) {
      throw new Error(
        errorMessage?.(key) ?? `Object must have property: ${key}`,
      );
    }
  }
}
